import { Util } from '../../common/util/util';
import { INavigation } from '../../shared/types/catalog';

export const getBreadcrumbs = (
  windowWidth: number,
  navigation: INavigation[]
) => {
  const content = [];
  let width =
    Util.getTextWidth('Главная / ' + navigation?.[0]?.title, '14px open sans') +
    150;
  for (let i = navigation?.length - 1; i > 0; i--) {
    if (
      Util.getTextWidth(navigation[i]?.title, '14px open sans') + 40 + width <=
      windowWidth
    ) {
      content.unshift(navigation[i]);
      width += Util.getTextWidth(navigation[i]?.title, '14px open sans') + 40;
    } else {
      return content;
    }
  }

  return content;
};
